import { z } from "zod";

export const shippingPriceSchema = z.object({
    shipping_method_id: z.number().min(1, "اختر شركة الشحن"),
    origin_country_id: z.number().min(1, "اختر دولة المنشأ"),
    origin_region_id: z.number().min(1, "اختر منطقة المنشأ"),
    origin_city_id: z.number().min(1, "اختر محافظة المنشأ"),
    destination_country_id: z.number().min(1, "اختر دولة الوجهة"),
    destination_region_id: z.number().min(1, "اختر منطقة الوجهة"),
    destination_city_id: z.number().min(1, "اختر محافظة الوجهة"),
    weight: z.preprocess(
        (val) => Number(val),
        z.number().min(0, "الوزن يجب أن يكون 0 أو أكثر")
    ),
    height: z.preprocess(
        (val) => Number(val),
        z.number().min(0, "الارتفاع يجب أن يكون 0 أو أكثر")
    ),
    width: z.preprocess(
        (val) => Number(val),
        z.number().min(0, "العرض يجب أن يكون 0 أو أكثر")
    ),
    depth: z.preprocess(
        (val) => Number(val),
        z.number().min(0, "العمق يجب أن يكون 0 أو أكثر")
    ),
    price: z.preprocess(
        (val) => Number(val),
        z.number().min(0, "السعر يجب أن يكون 0 أو أكثر")
    ),
});
